module.exports = __webpack_public_path__ + "static/media/liveIcon.c4dc8192.svg";